import { Component, OnInit, Input, TemplateRef, ViewChild, ViewEncapsulation } from '@angular/core';
import { UXControllerService } from '../service/controller/ux-controller.service';
import { CosyCommunicationControllerService } from '../service/controller/cosy-communication-controller.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap/modal';
import { DragulaService } from 'ng2-dragula';
import { CosyDynaeditorControllerService } from '../service/controller/cosy-dynaeditor-controller.service';
import { Subscription } from 'rxjs';
import { InterfaceElement } from '../model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { InterfaceElementTypes } from '../model/interfaceElement/interfaceElement-properties/interfaceElement-type';

//import * as _ from 'lodash';
import cloneDeep from 'lodash-es/cloneDeep';

@Component({
  selector: 'app-cosy-dynaeditor',
  templateUrl: './cosy-dynaeditor.component.html',
  styleUrls: ['./cosy-dynaeditor.component.css'],
  
})

export class CosyDynaeditorComponent implements OnInit {
  private subscriptionDE: Subscription;
  @Input() 
  viewAreaTemplateID;
  @ViewChild('dynaEditorTemplate')
  dynaEditorTemplate: TemplateRef<any>;
  public dynaIE: InterfaceElement;
  public dynaItem: any;
  public modalRef: BsModalRef;
  private IE_TYPES = InterfaceElementTypes;

  constructor(private uxControllerService: UXControllerService,
    private cosyCommunicationControllerService: CosyCommunicationControllerService,
    private cosyDynaeditorControllerService: CosyDynaeditorControllerService,
    private modalService: BsModalService,
    private dragulaService: DragulaService
  ) { }

  ngOnInit() {
    this.dragulaService.drag("dragula").subscribe(value => { });
      this.subscriptionDE = this.uxControllerService.showDynaEditor.subscribe(
        (data) => {
          data.template = this.dynaEditorTemplate;
          this.dynaIE = data;
          this.openDynaEditor(data.ie, this.dynaEditorTemplate); 
        }
      );
  }
  ngOnDestroy() {
    if (this.subscriptionDE != null) 
    {  this.subscriptionDE.unsubscribe();
       this.uxControllerService.isDynaFunctionCompleted = false;
    }
  }

 closeDragulaModal() {
    // this.dragulaService.destroy('entity-items');
   
  }

 saveDynaEditorData(updatedDynaForm, actionType) {
    if(actionType==null) actionType="update";
    this.cosyDynaeditorControllerService.saveDynaEditorResults(
      actionType,
      updatedDynaForm,
      this.uxControllerService.cosyFormInitProperties,
      this.dynaIE['ie'],
      this.dynaItem
    );
  
    if (updatedDynaForm == null && actionType == 'save') {
      this.cosyDynaeditorControllerService.previousProcessedCASD =  cloneDeep(this.cosyDynaeditorControllerService.processedCASD);
      this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument =  cloneDeep(this.cosyDynaeditorControllerService.processedCASD); 
      this.uxControllerService.isDynaFunctionCompleted = true;
      this.cosyCommunicationControllerService.postUpdatedCosyCustomDocument(
        this.cosyCommunicationControllerService.localSessionID,
        this.uxControllerService.cosyFormInitProperties.CustomAppStateDocument
      );
    }
  }

  openDynaEditor(ie: InterfaceElement, template: TemplateRef<any>) {
    //this.modalRef = this.modalService.show(template);
    this.modalRef = this.modalService.show(template, { class: 'modal-lg modal-dialog-scrollable' });
  }
  

}


